import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { MessageSquareText, X } from "lucide-react";
import DatePicker from "react-datepicker";
import { formatDate } from "../../helpers";
import Spacing from "../Spacing";
import { Drawer } from 'vaul';

const customSelectStyles = {
  control: (base, state) => ({
    ...base,
    border: "1px solid #D1D5DB",
    minHeight: '40px',
    borderRadius: '8px',
    boxShadow: state.isFocused ? "0 0 0 .5px var(--accent)" : "none",
    "&:hover": {
      borderColor: "#9CA3AF",
    },
  }),
  placeholder: (base) => ({
    ...base,
    fontSize: "0.875rem",
    color: "#9CA3AF",
    fontWeight: "normal",
  }),
  option: (base) => ({ ...base, cursor: "pointer" }),
  menuPortal: (base) => ({ ...base, zIndex: 999999 }),
  menu: (base) => ({
    ...base,
    marginTop: '-1px',
    border: "1px solid #D1D5DB",
    borderRadius: "0 0 0.375rem 0.375rem",
    zIndex: 999999,
  }),
};

export default function AppointmentConfirmationModal({
  handleAppointmentConfirmation = () => {},
  onClose = () => {},
  selectedAppointment = null,
  account_id,
  location_id,
  activeModal = false,
  smsLimit = 0,
}) {
  const dropdownRef = useRef(null);
  const [startDate, setStartDate] = useState(selectedAppointment?.preferred_date_1 || "");
  const [startDate2, setStartDate2] = useState(selectedAppointment?.preferred_date_2 || "");
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(selectedAppointment?.appointment_time || "");
  const [sendSMS, setSendSMS] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    let el = document.getElementById("docpro-datepicker-portal");
    if (!el) {
      el = document.createElement("div");
      el.id = "docpro-datepicker-portal";
      document.body.appendChild(el);
    }
  }, []);

  const handleConfirmAppointment = () => {
    if (selectedTimeSlot === "") {
      onClose();
      return;
    }
    const postData = {
      account_id: account_id,
      location_id: location_id,
      preferred_date_1: formatDate(startDate),
      preferred_date_2: formatDate(startDate2),
      status: "confirmed",
      appointment_time: selectedTimeSlot,
      dont_send_sms: sendSMS,
      hex_id: selectedAppointment.hex_id,
    };
    handleAppointmentConfirmation(postData);
    onClose();
  };

  const handleSelecTimeSlot = (e) => {
    setSelectedTimeSlot(e.value);
  };

  const handleSendSMSCheck = (e) => {
    const isChecked = e.target.checked;
    if(isChecked){
      setSendSMS(true);
    } else {
      setSendSMS(false)
    }
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={activeModal} onOpenChange={onClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4 medium">
            <Drawer.Title className="sr-only">OTP Confirmation</Drawer.Title>
            <Drawer.Description className="sr-only">OTP confirmation modal for send email</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_2 docpro_style_auto">
              <div className="docpro_modal">
                <div className="modal_height_100">
                  <div>
                    <button
                      className="docpro_close_btn"
                      onClick={onClose}
                    >
                      <X />
                    </button>
                    <h2 className="docpro_fs_24 docpro_mb_0">Appointment Confirmation</h2>
                    <Spacing lg="20" sm="20" />
                    <label className="docpro_fw_500 docpro_primary_color">
                      Preferred Date
                    </label>
                    <DatePicker
                      selected={startDate}
                      className="size_lg"
                      onChange={(date) => setStartDate(date)}
                      placeholderText='mm/dd/yyyy'
                      // minDate={new Date()}
                      popperProps={{ strategy: "fixed" }}
                      popperClassName="docpro_datepicker_popper"
                    />
                    <Spacing lg="20" sm="20" />
                    <label className="docpro_fw_500 docpro_primary_color">
                      Second Preferred Date
                    </label>
                    <DatePicker
                      selected={startDate2}
                      className="size_lg"
                      onChange={(date) => setStartDate2(date)}
                      placeholderText='mm/dd/yyyy'
                      // minDate={new Date()}
                      popperProps={{ strategy: "fixed" }}
                      popperClassName="docpro_datepicker_popper"
                    />
                    <Spacing lg="20" sm="20" />
                    <label className="docpro_fw_500 docpro_primary_color">
                      Appointment Time{" "}
                      <span className="docpro_accent_color docpro_fw_500 docpro_fs_12">
                        Previous timeslot: {selectedAppointment?.appointment_time || ""}
                      </span>
                    </label>
                    <Select
                      required
                      options={[
                        { value: "Anytime of the day", label: "Anytime of the day" },
                        { value: "Morning", label: "Morning" },
                        { value: "Afternoon", label: "Afternoon" },
                        { value: "Evening", label: "Evening" }
                      ]}
                      onChange={handleSelecTimeSlot}
                      placeholder="Select time of day..."
                      isSearchable={true}
                      value={
                        selectedTimeSlot
                          ? { value: selectedTimeSlot, label: selectedTimeSlot }
                          : null
                      }
                      className="react-select-container w-full"
                      classNamePrefix="react-select"
                      styles={customSelectStyles}
                    />
                    <Spacing lg="20" sm="20" />
                    <p className="docpro_fw_500 mb-1 docpro_accent_color">Your Available Message Credit: {smsLimit.available_credit}</p>
                    <div className="docpro_checkbox docpro_tip_checkbox" >
                      <input
                        type="checkbox"
                        value={true}
                        name="id" 
                        onChange={handleSendSMSCheck}
                      />
                      <label style={{ marginLeft: "8px" }}> Avoid sending a text message to the patient. </label>
                      <span className="docpro_tip" style={{ textAlign: 'center' }}>If checked, the patient has not received <br />any confirmation SMS</span>
                    </div>
                    <Spacing lg="20" sm="20" />
                  </div>
                  <button
                    className="docpro_bordered_btn docpro_fw_600 docpro_white_color docpro_filed_btn docpro_mt_auto"
                    style={{ width: "100%", padding: "10px 12px" }}
                    onClick={handleConfirmAppointment}
                  >
                    <MessageSquareText width={20} height={20} />
                    <span>Confirm Appointment</span>
                  </button>
                </div>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
